import { z } from 'zod';
import type { Membership, Owner } from '../types/state';

export const legalInfoSchema = z.object({
  powered: z.boolean({ message: 'This field is required' }),
  usPerson: z.boolean({ message: 'This field is required' }),
  selfPepDeclaration: z.boolean({ message: 'This field is required' }),
});

export type LegalInfoSchema = z.infer<typeof legalInfoSchema>;

export function hasLegalInfo(owner: Owner): boolean {
  return legalInfoSchema.safeParse({
    powered: owner.powered,
    usPerson: owner.usPerson,
    selfPepDeclaration: owner.selfPepDeclaration,
  }).success;
}

export function requiresRepresentative(owner: Owner): boolean {
  return Boolean(owner.powered);
}

export const representativeSchema = z.object({
  firstName: z.string().nonempty(),
  lastName: z.string().nonempty(),
  email: z.email(),
  birthdate: z.string(),
  birthCity: z.string().nonempty(),
  birthCountry: z.string().nonempty(),
  nationality: z.string().nonempty(),
});

export function hasLegalRepresentative(memberships: Membership[]): boolean {
  const representative = memberships.find(m => m.corporateOfficer === true);

  if (!representative) {
    return false;
  }

  const isInfoValid = representativeSchema.safeParse({
    firstName: representative.firstName,
    lastName: representative.lastName,
    email: representative.email,
    birthdate: representative.birthdate,
    birthCity: representative.birthCity,
    birthCountry: representative.birthCountry,
    nationality: representative.nationality,
  }).success;

  // Document validation included but not enforced yet (as per Q4B)
  // const hasDocument = Boolean(representative.hasPoiDocument);

  return isInfoValid;
}
